(ns net.kestec.mhda-pilgrimage.admin.applications.application-detail-data-view
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Table" :default Table]
    ["@mui/material/Button" :default Button]
    ["@mui/material/TableBody" :default TableBody]
    ["@mui/material/TableRow" :default TableRow]
    ["@mui/material/TableCell" :default TableCell]
    ["@mui/material/Chip" :default Chip]

    ["@mui/icons-material/CheckCircleOutline" :default CheckIcon]
    ["@mui/icons-material/HighlightOff" :default UnCheckIcon]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field text-field-multi select radio-yes-no]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]


    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))


(defn yes-no-val [val]
  (case val
    true "Ja"
    false "Nein"
    "---"))

(defn validator-details []
  (let [validation-info @(rf/subscribe [::db/get ::db/admin-selected-application-validation])]
    [:<>
     [grid-full [:> Typography {:variant "h3"} "Formular-Validierung: "]]
     [grid-full [:> Typography {:variant "p"} "Fehler in folgenden Feldern"]]
     [grid-full
      ;[:pre " Valid: " application-id " -- " (pr-str (:fields-missing validation-info))]
      [:> Table
       (into
         [:> TableBody]
         (for [block (:fields-missing validation-info)]
           [:> TableRow
            [:> TableCell {:style {:font-size "10px"}} (str (:name block))]
            (into [:> TableCell]
                  (for [m (:missing block)]
                    [:> Chip {:label (str m)
                              :sx    {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)" :font-size "9px" :height "17px"}}]
                    ))
            ]))
       ]]]))

(defn data-view []
  (let [application @(rf/subscribe [::db/get ::db/admin-selected-application])]
    [:<>
     [grid-full [:> Typography {:variant "h3"} "Anmeldung: "]]
     ;[grid-full
     ; [:span " Appl: " application-id " -- " (pr-str application)]]

     [grid-full
      [:> Table
       [:> TableBody
        [:> TableRow
         [:> TableCell
          [:span "Rufname"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:shown_first_name application)]]
         [:> TableCell
          [:span "Familienname"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:shown_last_name application)]]]


        [:> TableRow
         [:> TableCell
          [:span "Vorname"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:given_name application)]]
         [:> TableCell
          [:span "Nachname nach Pass"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:family_name application)]]]

        [:> TableRow
         [:> TableCell
          [:span "Ausweisnummer"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:id_number application)]]
         [:> TableCell
          [:span "Ausstellungsdatum"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (first (clojure.string/split (:id_date application) #"T"))]]]

        [:> TableRow
         [:> TableCell
          [:span "Ausweis gültig bis"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (first (clojure.string/split (:id_valid_until application) #"T"))]]
         [:> TableCell
          [:span ""]]
         [:> TableCell
          [:span ""]]]

        [:> TableRow
         [:> TableCell
          [:span "Adresse"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:street_address application)]]
         [:> TableCell
          [:span ""]]
         [:> TableCell
          [:span ""]]]

        [:> TableRow
         [:> TableCell
          [:span "Plz"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:zip application)]]
         [:> TableCell
          [:span "Ort"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:city application)]]]

        [:> TableRow
         [:> TableCell
          [:span "Geburtsdatum"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (first (clojure.string/split (:birthdate application) #"T"))]]
         [:> TableCell
          [:span "Geburtsort"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:birthtown application)]]]

        [:> TableRow
         [:> TableCell
          [:span "Mobilnummer"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:phone application)]]
         [:> TableCell
          [:span "Email"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:email application)]]]



        [:> TableRow
         [:> TableCell {:colSpan 4}
          [:hr]
          ]]


        [:> TableRow
         [:> TableCell
          [:span "Ist Malteser"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:mhda_member application))]]
         [:> TableCell
          [:span "Möchte mitfahren als"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:mhda_type application)]]]

        [:> TableRow
         [:> TableCell
          [:span "Dienstnummer"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:mhda_service_no application)]]
         [:> TableCell
          [:span "Pflegefortbildung"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:mhda_certified application))]]]



        [:> TableRow
         [:> TableCell {:colSpan 4}
          [:hr]
          ]]

        [:> TableRow
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfsmittel/Hilfe wenn ich länger gehe (> 2km)"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_mobility_2km application))]]
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "nutze"] " folgendes Hilfsmittel"]]
         [:> TableCell
          (case (or (:mobility application) 0)
            0 [:span {:style {:color "darkblue"}} "kein Hilfsmittel"]
            2 [:span {:style {:color "darkblue"}} "gelegentlich Stock"]
            3 [:span {:style {:color "darkblue"}} "ich gehe mit Stock"]
            4 [:span {:style {:color "darkblue"}} "ich nutze einen Rollator"]
            5 [:span {:style {:color "darkblue"}} "ich nutze einen Rollstuhl"]
            6 [:span {:style {:color "darkblue"}} "ich nutze einen elektrischen Rollstuhl"]
            7 [:span {:style {:color "darkblue"}} "Rollstuhl nicht umsetzbar"]
            [:span {:style {:color "darkblue"}} "?" (:mobility application)])]
         ]

        [:> TableRow
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim Aufstehen oder Zubettgehen"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_bed application))]]

         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim An- und Auskleiden"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_clothing application))]]]

        [:> TableRow
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe bei der Körperpflege"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_hygiene application))]]
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim Essen und Trinken"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_feeding application))]]]

        [:> TableRow
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe auf der Toilette"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_toilette application))]]
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "leide"] " an einer schweren chronischen Krankheit"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_chronic_illness application))]]]

        [:> TableRow
         [:> TableCell
          [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " ärztliche oder pflegerische Betreuung"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:q_help_medical application))]]]

        [:> TableRow
         [:> TableCell {:colSpan 4}
          [:hr]
          ]]


        [:> TableRow
         [:> TableCell
          [:span "Diabetes"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:diet_diabetes application))]]
         [:> TableCell
          [:span "Zöliakie"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:diet_zoeliakie application))]]]

        [:> TableRow
         [:> TableCell
          [:span "Diät"]]
         [:> TableCell {:colSpan 3}
          [:span {:style {:color "darkblue"}} (:diet_text application)]]]


        [:> TableRow
         [:> TableCell {:colSpan 4}
          [:hr]
          ]]

        [:> TableRow
         [:> TableCell
          [:span "Reiseversicherung"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:insurance_provided application))]]
         [:> TableCell
          [:span "Zusatzversicherung buchen"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:insurance_booked application))]]]




        [:> TableRow
         [:> TableCell
          [:span "für das Bundesland"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:selected_division application))]]
         [:> TableCell
          [:span "Einzelzimmer gebucht"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (yes-no-val (:single_room_booked application))]]]

        [:> TableRow
         [:> TableCell
          [:span "Zimmer teilen mit"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}}  (:room_wishes application)]]
         [:> TableCell
          [:span ""]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} ""]]]

        [:> TableRow
         [:> TableCell
          [:span "Notfallkontakt"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:emergency_contact_name application)]]
         [:> TableCell
          [:span "Email"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:emergency_contact_email application)]]]

        [:> TableRow
         [:> TableCell
          [:span ""]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} ""]]
         [:> TableCell
          [:span "Tel"]]
         [:> TableCell
          [:span {:style {:color "darkblue"}} (:emergency_contact_phone application)]]]

        (when-not (= "" (:emergency_contact_name_2 application))
          [:> TableRow
           [:> TableCell
            [:span "Notfallkontakt 2"]]
           [:> TableCell
            [:span {:style {:color "darkblue"}} (:emergency_contact_name_2 application)]]
           [:> TableCell
            [:span "Email"]]
           [:> TableCell
            [:span {:style {:color "darkblue"}} (:emergency_contact_email_2 application)]]])

        (when-not (= "" (:emergency_contact_name_2 application))
          [:> TableRow
           [:> TableCell
            [:span ""]]
           [:> TableCell
            [:span {:style {:color "darkblue"}} ""]]
           [:> TableCell
            [:span "Tel"]]
           [:> TableCell
            [:span {:style {:color "darkblue"}} (:emergency_contact_phone_2 application)]]])

        ]]

      [grid-full]
      ]
     ]

    ))